module.exports = __webpack_public_path__ + "static/weatherApp-c17afe4c58fdc10681fe3e43cdeabc4a.png";